import React from 'react';
import { Banner } from '../../../types/banner';
import { getDisplayContent } from '../../../utils';

const useBannerFilters = (banners: Banner[]) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredBanners = React.useMemo(() => {
    if (!searchTerm.trim()) {
      return banners;
    }

    const searchLower = searchTerm.toLowerCase();

    return banners.filter(banner => {
      // Búsqueda en display content
      if (getDisplayContent(banner).toLowerCase().includes(searchLower)) {
        return true;
      }

      // Búsqueda genérica en creativityConfig
      if (banner.creativityConfig) {
        const configString = JSON.stringify(banner.creativityConfig).toLowerCase();
        return configString.includes(searchLower);
      }

      return false;
    });
  }, [banners, searchTerm]);

  return {
    searchTerm,
    setSearchTerm,
    filteredBanners,
    totalItems: filteredBanners.length,
    totalBanners: filteredBanners.length
  };
};

export { useBannerFilters };
